import { API_URL } from '@/const'
import { customAxios } from '@/utils'

export const fetchDocuments = (page?: number) => {
  let url = `${API_URL}/accounting/documents/`
  if (page) {
    url = `${url}?page=${page}`
  }
  return customAxios(url, 'GET', null, true)
}

export const updateDocuments = () => {
  const url = `${API_URL}/accounting/documents/`
  return customAxios(url, 'GET', null, true)
}

export const downloadFile = (path: string) => {
  const url = `${API_URL}/${path}`
  return customAxios(url, 'GET', null, true, { 'Content-type': 'application/pdf' }, 'arraybuffer').then(
    (response) => response.data
  )
}
